import { render, staticRenderFns } from "./WithoutPhotoTab.vue?vue&type=template&id=1ac36034&scoped=true&"
import script from "./WithoutPhotoTab.vue?vue&type=script&lang=js&"
export * from "./WithoutPhotoTab.vue?vue&type=script&lang=js&"
import style0 from "./WithoutPhotoTab.vue?vue&type=style&index=0&id=1ac36034&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac36034",
  null
  
)

export default component.exports